
import { defineComponent, computed, onMounted, onUnmounted, ref, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
import {
  MypageUserRanking,
  MypageFoodsRanking
} from "@/types/mypage";
import MypageFoodsRankingContentFoodsRankingCard from "@/components/mypage/MypageFoodsRankingContentFoodsRankingCard.vue";

export default defineComponent({
  name: "MypageFoodsRankingContent",
  components: {
    MypageFoodsRankingContentFoodsRankingCard
  },
  props: {
    /** ユーザー・ランキング */
    userRanking: {
       type: MypageUserRanking,
       default: null
    },
    /** 個人使い切り食品ランキング */
    personalUsedFoodsRanking: {
      type: MypageFoodsRanking,
      default: null
    },
    /** 個人使い切り食品ランキング */
    personalDisposedFoodsRanking: {
      type: MypageFoodsRanking,
      default: null
    },
    /** 全国使い切り食品ランキング */
    nationwideUsedFoodsRanking: {
      type: MypageFoodsRanking,
      default: null
    },
    /** 全国使い切り食品ランキング */
    nationwideDisposedFoodsRanking: {
      type: MypageFoodsRanking,
      default: null
    }
  },
  setup(props, context: SetupContext) {
    const userRankingTitleText = "あなたの使い切り度は\n全体を100人とした場合";
    const usedFoofdsRankingTitleText = "使い切り食材ランキング";
    const disposedFoofdsRankingTitleText = "捨てた食材ランキング";
    const userTitleText = "あなた";
    const nationwideTitleText = "全国";
    const firstRankText = "1位";
    const secondRankText = "2位";
    const thirdRankText = "3位";

    const rankText = computed(() => {
      if (props.userRanking == null || props.userRanking.rank == null) {
        return "";
      }
      return `${props.userRanking.rank!}`;
    });

    const clickQuestion = () => {
      NativeClient.sendDebugLog("MypageFoodsRankingContent clickQuetion");
      context.emit("click-quetion");
    };

    const clickUsedArea = () => {
      NativeClient.sendDebugLog("MypageFoodsRankingContent clickUsedArea");
      context.emit("click-used");
    };

    const clickDisposedArea = () => {
      NativeClient.sendDebugLog("MypageFoodsRankingContent clickDisposedArea");
      context.emit("click-disposed");
    };

    return {
      userRankingTitleText,
      rankText,
      usedFoofdsRankingTitleText,
      disposedFoofdsRankingTitleText,
      userTitleText,
      nationwideTitleText,
      firstRankText,
      secondRankText,
      thirdRankText,
      clickQuestion,
      clickUsedArea,
      clickDisposedArea
    };
  }
});
